/**
 * Route-level hide rules for header widgets.
 *
 * Keys are route prefixes (matched with `startsWith` on `Router.url`) and
 * values list the widgets that should be hidden while the current URL is
 * under that prefix. This layers on top of the tenant-level gate — a widget
 * only renders when both the tenant gate passes AND the current route does
 * not appear in this map.
 *
 * Add new rules here rather than in `header.component.ts` so that all
 * route-based visibility lives in one place.
 */
export type HeaderWidget = 'language' | 'currency' | 'notification' | 'search';

export const HEADER_HIDE_RULES: Readonly<Record<string, ReadonlyArray<HeaderWidget>>> = {
  '/savings-recommendations': ['currency', 'language'],
  '/view-PDF': ['currency', 'language'],
  '/users': ['currency'],
};
